<div class="neti-next-order-amount-handler-context-menu-plugin">
    <a
        :href="documentationLink"
        class="sw-context-menu-item"
        target="_blank"
    >
        {{ $t('neti-order-amount-handler.config.links.buttonDocumentation') }}
    </a>

    <a
        :href="supportLink"
        class="sw-context-menu-item"
        target="_blank"
    >
        {{ $t('neti-order-amount-handler.config.links.buttonSupport') }}
    </a>

    <a
        :href="descriptionLink"
        class="sw-context-menu-item"
        target="_blank"
    >
        {{ $t('neti-order-amount-handler.config.links.buttonDescription') }}
    </a>
</div>